import axios from "axios";

export const LOGIN_URL = `/v2/account/login`;
export const REGISTER_URL = "/v2/user/register";
export const REGISTER_CONFIG_URL = "/v2/user/register/config";
export const REQUEST_PASSWORD_URL = `/v2/account/forgot`;
export const RESET_PASSWORD_URL = `/v2/account/reset`;
export const ME_URL = `/v2/account/me`;
export const UPDATE_USER_URL = "/v2/user/update/";
export const CHANGE_PASSWORD_URL = "/v2/account/changepassword";
export const DELETE_ACCOUNT_URL = "/v2/user/delete-account/";
export const COMPANIES_URL = "/v2/user/companies";
export const SWITCH_COMPANY_URL = "/v2/user/switch-company";
export const ADD_TO_COMPANY_URL = "/v2/user/add-to-company";
export const REMOVE_FROM_COMPANY_URL = "/v2/user/remove-from-company";
export const VERIFY_EMAIL_URL = "/v2/account/verify-email";
export const RESEND_VERIFICATION_URL = "/v2/account/resend-verification";
export const REFRESH_URL = "/v2/account/refresh";
export const LOGOUT_URL = "/v2/account/logout";

// The refresh token is an HTTP-only cookie; these calls only need the marker header the server requires.
const SESSION_REQUEST = { withCredentials: true, headers: { "X-Requested-With": "XMLHttpRequest" } };

export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password });
}

export function logoutSession() {
  return axios.post(LOGOUT_URL, {}, { ...SESSION_REQUEST, timeout: 5000 });
}

export function register(values) {
  return axios.post(REGISTER_URL, { ...values });
}

// The public Turnstile site key (not a secret) and a signed form token for the sign-up page.
export function getRegisterConfig() {
  return axios.get(REGISTER_CONFIG_URL);
}

// A friendly message for a failed auth call: too many requests, a failed security check, or the server's own text.
export function authErrorMessage(err, fallback) {
  const response = err && err.response;
  if (!response) return "We could not reach the server. Check your connection and try again.";
  if (response.status === 429) {
    const seconds = parseInt(response.headers && response.headers["retry-after"], 10);
    const wait = seconds > 0 ? ` Please wait ${seconds >= 120 ? `${Math.ceil(seconds / 60)} minutes` : `${seconds} seconds`} and try again.` : " Please wait a few minutes and try again.";
    return `Too many attempts.${wait}`;
  }
  const data = response.data;
  if (data && typeof data === "object" && typeof data.message === "string") return data.message;
  if (typeof data === "string" && data && data.length < 300) return data;
  return fallback;
}

export function verifyEmail(token) {
  return axios.get(`${VERIFY_EMAIL_URL}/${token}`);
}

export function resendVerification(email) {
  return axios.post(RESEND_VERIFICATION_URL, { email });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function resetPassword(token, password) {
  return axios.post(`${RESET_PASSWORD_URL}/${token}`, { password });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}

export function updateUser(value) {
  return axios.put(`${UPDATE_USER_URL}${value && value._id}`, { ...value });
}

export function changePassword(value) {
  return axios.post(CHANGE_PASSWORD_URL, { ...value });
}

export function updateNotificationSettings(value) {
  return axios.post(`/v2/settings/${value.userId}`, { ...value });
}

export function deleteAccount(userId) {
  return axios.put(`${DELETE_ACCOUNT_URL}${userId}`);
}

export function getUserCompanies() {
  return axios.get(COMPANIES_URL);
}

export function switchCompany(companyId) {
  return axios.post(SWITCH_COMPANY_URL, { companyId });
}

export function addUserToCompany(email, userRole) {
  return axios.post(ADD_TO_COMPANY_URL, { email, userRole });
}

export function removeFromCompany(companyId, userId) {
  return axios.delete(`${REMOVE_FROM_COMPANY_URL}/${companyId}`, { data: { userId } });
}
